import type { SVGProps } from "react";

export function IconBlack3Packages(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.75 6.25H44.5V31.25H19.5V6.25H31.25V12.75H32.75V6.25ZM6.25 32.75V57.75H31.25V32.75H19.5V38.75H18V32.75H6.25ZM32.75 57.75H57.75V32.75H46V38.75H44.5V32.75H32.75V57.75Z"
        fill="#23232C"
      />
    </svg>
  );
}
